import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { AdminUserInfo } from '../fragments';

export default gql`
  mutation createAdminUser($input: AdminUserCreateInput!) {
    createAdminUser(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      adminUser {
        ...AdminUserInfo
      }
    }
  }
  ${AdminUserInfo}
  ${ErrorMessageInfo}
`;
